import { Config } from "../model/model"
import ObjectUtil from "../util/ObjectUtil"

/**
 * An interface model for Parameter Config
 */
export interface ParameterConfig extends Config {
  readonly parameters: Record<string, string | number | boolean>
}

export class EmptyParameterConfig implements ParameterConfig {
  readonly parameters: Record<string, string | number | boolean> = {}

  get(key: string, defaultValue: string): string
  get(key: string, defaultValue: number): number
  get(key: string, defaultValue: boolean): boolean
  get(key: string, defaultValue: string | number | boolean): string | number | boolean {
    return defaultValue
  }
}

export class DefaultParameterConfig implements ParameterConfig {
  constructor(readonly parameters: Record<string, string | number | boolean>) {}

  get(key: string, defaultValue: string): string
  get(key: string, defaultValue: number): number
  get(key: string, defaultValue: boolean): boolean
  get(key: string, defaultValue: string | number | boolean): string | number | boolean {
    const parameterValue = this.parameters[key]

    if (ObjectUtil.isNullOrUndefined(parameterValue)) {
      return defaultValue
    }

    if (ObjectUtil.isNullOrUndefined(defaultValue)) {
      return parameterValue
    }

    if (typeof parameterValue === typeof defaultValue) {
      return parameterValue
    }

    return defaultValue
  }
}
